import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const OccupationsIcon = ({ label = 'Occupations', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M36.5 165.8v61.1a17.4 17.4 0 0 0 17.6 17.6h188.2a17.4 17.4 0 0 0 17.6-17.6v-61.1h-78.6v5a9.6 9.6 0 0 1-9.6 9.5h-47a9.4 9.4 0 0 1-9.5-9.5v-5z" style="fill:#85cee3"/><path d="M259.9 165.8v61.1a17.4 17.4 0 0 1-17.6 17.6H54.1a17.4 17.4 0 0 1-17.6-17.6v-61.1h78.7v5a9.4 9.4 0 0 0 9.5 9.5h47a9.6 9.6 0 0 0 9.6-9.5v-5h78.6m0-10h-78.6a10 10 0 0 0-10 10v4.5h-46.1v-4.5a10 10 0 0 0-10-10H36.5a10 10 0 0 0-10 10v61.1a27.5 27.5 0 0 0 27.6 27.6h188.2a27.3 27.3 0 0 0 27.6-27.6v-61.1a10 10 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M202 98.6V76.8a17.6 17.6 0 0 0-17.6-17.6H112a17.6 17.6 0 0 0-17.6 17.6v21.8" style="fill:#fff"/><path d="M202 103.6a5.1 5.1 0 0 1-5-5V76.8a12.6 12.6 0 0 0-12.6-12.6H112a12.6 12.6 0 0 0-12.6 12.6v21.8a5 5 0 0 1-10 0V76.8A22.5 22.5 0 0 1 112 54.2h72.4A22.5 22.5 0 0 1 207 76.8v21.8a5 5 0 0 1-5 5z" style="fill:#1d1d1b"/><path d="M50.5 107.9h195.4a14 14 0 0 1 14 14v30.6H36.5v-30.6a14 14 0 0 1 14-14z" style="fill:#85cee3"/><path d="M245.9 107.9a14 14 0 0 1 14 14v30.5H36.5v-30.5a14 14 0 0 1 14-14h195.4m0-10H50.5a24 24 0 0 0-24 24v30.5a10 10 0 0 0 10 10h223.4a10 10 0 0 0 10-10v-30.5a24 24 0 0 0-24-24zm-6.1 137.5h-28.7a3.5 3.5 0 0 1 0-7h28.7a2 2 0 0 0 2-2v-4.8a3.5 3.5 0 0 1 3.5-3.5 3.4 3.4 0 0 1 3.5 3.5v4.8a9 9 0 0 1-9 9zm5.5-22.4a3.5 3.5 0 0 1-3.5-3.5v-4.3a3.5 3.5 0 0 1 3.5-3.5 3.4 3.4 0 0 1 3.5 3.5v4.3a3.5 3.5 0 0 1-3.5 3.5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

OccupationsIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { OccupationsIcon }
